// 头部下拉管理api
import {message} from '../../util/message';
import {LogoutApi} from '../utils/index.js';
import router from "../../router";
import Qs from 'qs';
import axios from "axios";
import fetch from "../axiosConfig";


// var Token = localStorage.getItem("_eToken");
// var headers = Token == null ? {} : { "Token": Token.replace(/\"/g, "") };
//退出登录
export function Logout(data) {
  LogoutApi().then((res) => {
    storage.remove('token');
    router.replace({path: '/login'})
  });
}

//修改密码
export function updatePersonPwd(data) {
  return fetch({
    url: "/user/updatePersonPwd",
    method: "post",
    data:data,
  });
}

//oa登录
export function goToOA() {
  return fetch({
    url: "/sso/login",
    method: "get",
  });
}


//修改密码
// export function updatePersonPwd(data) {
//   data = Qs.parse(data)
//   return new Promise((resolve, reject) => {
//     axios({
//       method: 'post',
//       url: process.env.SSO_API + "user/updatePersonPwd",
//       headers: headers,
//       data: data,
//     })
//       .then((res) => {
//         resolve(res.data);
//         // console.log(res);
//       })
//       // .catch(function (error) {
//       //   reject(error);
//       //   // console.log(error);
//       // });
//
//   })
// }



// WEBPACK FOOTER //
// ./src/api/system/header.js